export enum EmployeeDetailFormFields {
  FirstName = 'firstName',
  LastName = 'lastName',
  FullName = 'fullName'
}
